import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/img/syotoku_01.png")